var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.77 5.27l-8-3.126a2.116 2.116 0 00-1.54 0l-8 3.125a1.977 1.977 0 00-.894.691C2.116 6.268 2 6.63 2 7c0 7.753 4.77 13.114 9.23 14.856a2.116 2.116 0 001.54 0C16.335 20.463 22 15.644 22 7c0-.37-.117-.732-.336-1.04a1.977 1.977 0 00-.895-.69zm-8.514 15.432a.737.737 0 01-.513 0C7.667 19.187 3.333 13.875 3.333 7c0-.253.161-.48.41-.577l8-3.125a.705.705 0 01.513 0l8 3.125a.657.657 0 01.299.23.596.596 0 01.112.347c0 6.875-4.334 12.188-8.41 13.702zm6.028-11.7l-7.52 6.994a.524.524 0 01-.707-.003l-3.579-3.382a.448.448 0 01.003-.662l.355-.33a.524.524 0 01.707.002l2.874 2.716 6.81-6.333a.524.524 0 01.707.003l.352.333a.448.448 0 01-.002.662z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.39db64a29ce32ff300c466e612a978a1.svg";
export { ForwardRef as ReactComponent };